<template lang="">
	<div id="content">
		<div class="global_area">
			<div class="path"><a href="#none">Home</a> &gt; <a href="#none">기타 관리</a> &gt; <strong>거래처 관리</strong></div>
			<h2 class="h_sub">거래처 관리</h2>
		</div>

    <MerchantManageListForm/>
  </div>
</template>

<script>
import MerchantManageListForm from '@/components/admin/merchant/MerchantManageListForm.vue';

export default {
  components: {
    MerchantManageListForm
  }
}
</script>
<style lang="">
    
</style>